// MessageModal.jsx (A separate file for a reusable component)
import React from 'react';
import ReactDOM from 'react-dom';

const MessageModal = ({ messages, onClose }) => {
  // If there are no messages, don't render anything
  if (!messages || messages.length === 0) {
    return null;
  }

  // Use a React Portal to render the modal content directly to the document body
  return ReactDOM.createPortal(
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
        <div className="custom-modal-header">
          <h3>New Message</h3>
          <button className="custom-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="custom-modal-body">
          {messages.map((message, index) => (
            <p key={index}>{message}</p>
          ))}
        </div>
        <div className="custom-modal-footer">
          <button className="custom-modal-ok" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>,
    document.body // The target DOM node to append to
  );
};

export default MessageModal;